import { StatusBox } from '@ui';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ModalCopySC } from '../../modal/modal.styled';

type TProps = {
  fullName: string;
};

const SuccessModal: React.FC<TProps> = ({ fullName }) => {
  return (
    <>
      <StatusBox
        title="Pacient pozvaný"
        description={
          <FormattedMessage
            id="patients_success.copy"
            values={{
              name: fullName,
              // @ts-expect-error
              b: (ch) => <b>{ch}</b>,
            }}
          />
        }
      />
    </>
  );
};

export default SuccessModal;
